import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#90caf9',
            light: '#e3f2fd',
            dark: '#42a5f5',
            contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        secondary: {
            main: '#f48fb1',
            light: '#fce4ec',
            dark: '#ad1457',
            contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        background: {
            default: '#121212',
            paper: '#1e1e1e',
        },
        text: {
            primary: '#ffffff',
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        success: {
            main: '#66bb6a',  // Brighter green
            light: '#81c784',
            dark: '#388e3c',
            contrastText: '#000000',  // Black text for better contrast
        },
        warning: {
            main: '#ffb74d',  // Brighter orange
            light: '#ffcc80',
            dark: '#f57c00',
            contrastText: '#000000',  // Black text for better contrast
        },
        error: {
            main: '#ef5350',  // Brighter red
            light: '#e57373',
            dark: '#d32f2f',
            contrastText: '#ffffff',  // White text for errors
        },
        info: {
            main: '#42a5f5',  // Brighter blue
            light: '#64b5f6',
            dark: '#1976d2',
            contrastText: '#000000',  // Black text for better contrast
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: '2.5rem',
            fontWeight: 500,
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 500,
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 500,
        },
        h4: {
            fontSize: '1.5rem',
            fontWeight: 500,
        },
        h5: {
            fontSize: '1.25rem',
            fontWeight: 500,
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 500,
        },
    },
    shape: {
        borderRadius: 8,
    },
    shadows: [
        'none',
        '0px 2px 1px -1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.07),0px 1px 3px 0px rgba(0,0,0,0.06)',
        '0px 3px 1px -2px rgba(0,0,0,0.1),0px 2px 2px 0px rgba(0,0,0,0.07),0px 1px 5px 0px rgba(0,0,0,0.06)',
        '0px 3px 3px -2px rgba(0,0,0,0.1),0px 3px 4px 0px rgba(0,0,0,0.07),0px 1px 8px 0px rgba(0,0,0,0.06)',
        // Add more shadows for elevations 4, 5, 6...
        '0px 2px 4px -1px rgba(0,0,0,0.12),0px 4px 5px 0px rgba(0,0,0,0.08),0px 1px 10px 0px rgba(0,0,0,0.07)',
        '0px 3px 5px -1px rgba(0,0,0,0.12),0px 5px 8px 0px rgba(0,0,0,0.08),0px 1px 14px 0px rgba(0,0,0,0.07)',
        '0px 3px 5px -1px rgba(0,0,0,0.14),0px 6px 10px 0px rgba(0,0,0,0.08),0px 1px 18px 0px rgba(0,0,0,0.07)',
        '0px 4px 5px -2px rgba(0,0,0,0.14),0px 7px 10px 1px rgba(0,0,0,0.08),0px 2px 16px 1px rgba(0,0,0,0.07)',
        '0px 5px 5px -3px rgba(0,0,0,0.14),0px 8px 10px 1px rgba(0,0,0,0.08),0px 3px 14px 2px rgba(0,0,0,0.07)',
        // Continue with more shadows up to 24 if needed
        '0px 5px 6px -3px rgba(0,0,0,0.16),0px 9px 12px 1px rgba(0,0,0,0.08),0px 3px 16px 2px rgba(0,0,0,0.07)',
        '0px 6px 6px -3px rgba(0,0,0,0.16),0px 10px 14px 1px rgba(0,0,0,0.08),0px 4px 18px 3px rgba(0,0,0,0.07)',
        '0px 6px 7px -4px rgba(0,0,0,0.16),0px 11px 15px 1px rgba(0,0,0,0.08),0px 4px 20px 3px rgba(0,0,0,0.07)',
        '0px 7px 8px -4px rgba(0,0,0,0.16),0px 12px 17px 2px rgba(0,0,0,0.08),0px 5px 22px 4px rgba(0,0,0,0.07)',
        '0px 7px 8px -4px rgba(0,0,0,0.18),0px 13px 19px 2px rgba(0,0,0,0.08),0px 5px 24px 4px rgba(0,0,0,0.07)',
        '0px 7px 9px -4px rgba(0,0,0,0.18),0px 14px 21px 2px rgba(0,0,0,0.08),0px 5px 26px 4px rgba(0,0,0,0.07)',
        '0px 8px 9px -5px rgba(0,0,0,0.18),0px 15px 22px 2px rgba(0,0,0,0.08),0px 6px 28px 5px rgba(0,0,0,0.07)',
        '0px 8px 10px -5px rgba(0,0,0,0.18),0px 16px 24px 2px rgba(0,0,0,0.08),0px 6px 30px 5px rgba(0,0,0,0.07)',
        '0px 8px 11px -5px rgba(0,0,0,0.18),0px 17px 26px 2px rgba(0,0,0,0.08),0px 6px 32px 5px rgba(0,0,0,0.07)',
        '0px 9px 11px -5px rgba(0,0,0,0.20),0px 18px 28px 2px rgba(0,0,0,0.08),0px 7px 34px 6px rgba(0,0,0,0.07)',
        '0px 9px 12px -6px rgba(0,0,0,0.20),0px 19px 29px 2px rgba(0,0,0,0.08),0px 7px 36px 6px rgba(0,0,0,0.07)',
        '0px 10px 13px -6px rgba(0,0,0,0.20),0px 20px 31px 3px rgba(0,0,0,0.08),0px 8px 38px 7px rgba(0,0,0,0.07)',
        '0px 10px 13px -6px rgba(0,0,0,0.22),0px 21px 33px 3px rgba(0,0,0,0.08),0px 8px 40px 7px rgba(0,0,0,0.07)',
        '0px 10px 14px -6px rgba(0,0,0,0.22),0px 22px 35px 3px rgba(0,0,0,0.08),0px 8px 42px 7px rgba(0,0,0,0.07)',
        '0px 11px 14px -7px rgba(0,0,0,0.22),0px 23px 36px 3px rgba(0,0,0,0.08),0px 9px 44px 8px rgba(0,0,0,0.07)',
        '0px 11px 15px -7px rgba(0,0,0,0.22),0px 24px 38px 3px rgba(0,0,0,0.08),0px 9px 46px 8px rgba(0,0,0,0.07)',
    ],
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.2)',
                    backgroundColor: '#252525',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    backgroundColor: '#1e1e1e',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                size: 'small',
            },
        },
        MuiAlert: {
            defaultProps: {
                variant: 'filled', // Use filled variant for better contrast
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    fontWeight: 500,
                    fontSize: '0.95rem',
                    '& .MuiAlert-icon': {
                        fontSize: '1.25rem',
                        opacity: 0.9,
                    },
                    // Apply contrastText from palette
                    '&.MuiAlert-filledSuccess': {
                        backgroundColor: '#2e7d32',
                        color: '#000000', // Using black text for success
                        '& .MuiAlert-icon': {
                            color: '#a5d6a7',
                        },
                    },
                    '&.MuiAlert-filledInfo': {
                        backgroundColor: '#1565c0',
                        color: '#000000', // Using black text for info
                        '& .MuiAlert-icon': {
                            color: '#90caf9',
                        },
                    },
                    '&.MuiAlert-filledWarning': {
                        backgroundColor: '#ff9800', // Orange background
                        color: '#000000', // Black text
                        '& .MuiAlert-icon': {
                            color: '#ffecb3',
                        },
                    },
                    '&.MuiAlert-filledError': {
                        backgroundColor: '#c62828',
                        color: '#ffffff', // White text for errors
                        '& .MuiAlert-icon': {
                            color: '#ffcdd2',
                        },
                    },
                    // Standard variant (alternative)
                    '&.MuiAlert-standardSuccess': {
                        backgroundColor: 'rgba(102, 187, 106, 0.15)',
                        color: '#a5d6a7', // Light green text
                        borderLeft: '4px solid #66bb6a',
                        '& .MuiAlert-icon': {
                            color: '#66bb6a',
                        },
                    },
                    '&.MuiAlert-standardInfo': {
                        backgroundColor: 'rgba(66, 165, 245, 0.15)',
                        color: '#90caf9', // Light blue text
                        borderLeft: '4px solid #42a5f5',
                        '& .MuiAlert-icon': {
                            color: '#42a5f5',
                        },
                    },
                    '&.MuiAlert-standardWarning': {
                        backgroundColor: 'rgba(255, 183, 77, 0.15)',
                        color: '#ffcc80', // Light orange text
                        borderLeft: '4px solid #ffb74d',
                        '& .MuiAlert-icon': {
                            color: '#ffb74d',
                        },
                    },
                    '&.MuiAlert-standardError': {
                        backgroundColor: 'rgba(239, 83, 80, 0.15)',
                        color: '#ef9a9a', // Light red text
                        borderLeft: '4px solid #ef5350',
                        '& .MuiAlert-icon': {
                            color: '#ef5350',
                        },
                    },
                },
            },
        },
        MuiAlertTitle: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    fontSize: '1.1rem',
                    marginBottom: 4,
                    // Ensure title has good contrast too
                    '&.MuiAlertTitle-root + .MuiAlert-message': {
                        marginTop: 2,
                    },
                },
            },
        },
    },
});

export default darkTheme;